import { IFeaturesSpecification, IConfiguratorUIDto } from '@canvas-logic/clp-api-types';

export function getFeatures(view: IConfiguratorUIDto): IFeaturesSpecification {
  return Object.assign({ webAr: { enabled: false }, canvasLogicBranding: { enabled: false } }, view.features);
}

export function isWebArEnabled(view: IConfiguratorUIDto) {
  const features = getFeatures(view);
  return Boolean(features.webAr.enabled);
}

export function isCanvasLogicBrandingEnabled(view: IConfiguratorUIDto) {
  const features = getFeatures(view);
  return Boolean(features.canvasLogicBranding.enabled);
}

export function getCanvasLogicBrandingLink(view: IConfiguratorUIDto): string {
  const features = getFeatures(view);
  if (features.canvasLogicBranding.link) {
    return features.canvasLogicBranding.link;
  } else {
    return features.canvasLogicBranding ? 'https://canvaslogic.de/en/augmented-reality-product-configurator/' : '';
  }
}
